// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"CP","selections":"DP","pillsDesktopSearchMenu":"EP"};